import { Component, OnInit } from '@angular/core';
import { RepurchaseService } from '../../../repurchase/services/repurchase.service';
import { RepurchaseProductService } from '../../../repurchase/services/repurchase-product.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
import { ViewChild, ElementRef, ViewContainerRef } from '@angular/core';
import { ProductService } from '../../../products/services/product.service';
import { RepurchaseRenewalService } from '../../services/repurchase-renewal.service';
import { PersonService } from '../../../person/services/person.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { UserService } from '../../../common/services/user.service';
import { ShopService } from '../../../configuration/services/shop.service';
import { RepurchaseWithdrawalTicketService } from '../../services/repurchase-withdrawal-ticket.service';


declare let alasql;

@Component({
  selector: 'app-list-repurchase',
  templateUrl: './list-repurchase.component.html',
  styleUrls: ['./list-repurchase.component.css'],
  providers:[RepurchaseService,RepurchaseProductService,ProductService,RepurchaseRenewalService,PersonService,UserService,ShopService,RepurchaseWithdrawalTicketService]
})
export class ListRepurchaseComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  repurchases:any = [];
  filters:any = {
    barcode:{contains: ""},
    total_purchase_amount: {contains: ""},
    total_due_amount:{contains: ""},
    status:{contains: ""},
    nif: {contains: ""},
    name: {contains: ""},
    surname: {contains: ""}
  };
  productFilter:any = {
    brand:{contains: ""},
    model: {contains: ""},
    storage_capacity: {contains: ""},
    serial_number: {contains: ""},
    description: {contains: ""},
    imei:{contains: ""}
  };
  fromDate:any;
  untilDate:any;
  fromDueDate:any;
  untilDueDate:any;
  role:number = 3;
  exportParams:any ={};
  users:any = [];
  shops: any = [];

  @ViewChild('myfocusCP') myfocusCPElement: ElementRef;
 
  ngAfterViewInit() {
    this.myfocusCPElement.nativeElement.focus();
  }

  constructor(private repurchaseService: RepurchaseService,private route: ActivatedRoute,private router: Router, private repurchaseProductService:RepurchaseProductService, private userService:UserService,
              private productService:ProductService, private repurchaseRenewalService:RepurchaseRenewalService, private personService:PersonService,public toastr: ToastsManager, 
              private shopService:ShopService, vcr: ViewContainerRef, private repurchaseWithdrawalTicketService:RepurchaseWithdrawalTicketService) { 
                this.toastr.setRootViewContainerRef(vcr);
              }

  ngOnInit() {
    this.getRepurchases(null);
    this.getShops();
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;
      if (location.href.split('?')[1]){
        this.filters = JSON.parse(localStorage.getItem('repurchase-filter'));   
        this.productFilter = JSON.parse(localStorage.getItem('repurchase-filter-product')); 
        this.getFilters();
      }else{
        this.getRepurchases(null);
      }
      if (this.role === 1){
        this.getUsers();
      }
    }catch(e){
      this.getRepurchases(null);
    }
  }

  getShops(){
      this.shopService.query({})
      .subscribe((shops) => {
          this.shops = shops;
          this.shops.unshift({name:"Todas", id:-1})
      });
  }

  getUsers(){
    this.userService.query({})
        .subscribe((users) => {
            this.users = users;
            this.users.unshift({id:null, username:"Ninguno"});
        });
  }

  getFilters(){
    localStorage.setItem('repurchase-filter',JSON.stringify(this.filters));
    localStorage.setItem('repurchase-filter-product',JSON.stringify(this.productFilter));
    location.href = location.href.split('?')[0]+"?filters=true";
    if (this.filters && this.filters.createdBy == null){
      delete this.filters.createdBy;
    }
    if (this.filters.status.contains == "Fuera de fecha" || this.filters.status.contains == "fuera de fecha" ){
      this.getRepurchaseOutOfDate();
    }else if (this.filters.status.contains == "vigente" || this.filters.status.contains == "Vigente" ){
      this.getRepurchaseValid();
    }else if (this.productFilter.brand.contains != "" || this.productFilter.model.contains != "" || this.productFilter.storage_capacity.contains != "" ||
              this.productFilter.serial_number.contains != "" || this.productFilter.description.contains != "" || this.productFilter.imei.contains != ""){
        this.getRepurchasesByProducts(null);
    }else{
      this.getRepurchases(null);
    }

  }

  getRepurchasesByProducts(prefilter){
    let params = {
      where: _.cloneDeep(this.productFilter)
    };
    this.productService.query(params)
      .subscribe((products) => {
        var repurchases = _.compact(products.map(e => e.repurchaseProduct[0]?e.repurchaseProduct[0].repurchase:null));
        //Si existe un prefiltrado de recompras hacemos la intersección.
        if (prefilter != null){
          repurchases = _.intersection(repurchases,prefilter);
        }
        if (repurchases.length > 0){ 
          this.getRepurchases(repurchases);
        }else{
          this.repurchases = [];
        }
      });
  }

  getRepurchaseOutOfDate(){
    this.repurchaseService.getRepurchaseOutOfDate().subscribe((repurchases) => {
      if (this.productFilter.brand.contains != "" || this.productFilter.model.contains != "" || this.productFilter.storage_capacity.contains != "" ||
              this.productFilter.serial_number.contains != "" || this.productFilter.description.contains != "" || this.productFilter.imei.contains != ""){
        if (repurchases.length > 0){        
          this.getRepurchasesByProducts(repurchases.map(e => e.id));
        }else{
          this.repurchases = [];
        }
      }else{
        if (repurchases.length > 0){  
          this.getRepurchases(repurchases.map(e => e.id));
        }else{
          this.repurchases = [];
        }
      }
    });
  }

  getRepurchaseValid(){
    this.repurchaseService.getRepurchaseValid().subscribe((repurchases) => {
      if (this.productFilter.brand.contains != "" || this.productFilter.model.contains != "" || this.productFilter.storage_capacity.contains != "" ||
              this.productFilter.serial_number.contains != "" || this.productFilter.description.contains != "" || this.productFilter.imei.contains != ""){

        if (repurchases.length > 0){ 
          this.getRepurchasesByProducts(repurchases.map(e => e.id));
        }else{
          this.repurchases = [];
        }
      }else{
        if (repurchases.length > 0){ 
          this.getRepurchases(repurchases.map(e => e.id));
        }else{
          this.repurchases = [];
        }
      }
    });
  }

  getRepurchases(prefilter){
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (prefilter && !params.where.id){
      params.where.id = prefilter;
    }
    //Borramos el filtro de fuera de fecha, ya que este estado se filtra previamente
    if (this.filters.status.contains == "Fuera de fecha" || this.filters.status.contains == "fuera de fecha" || this.filters.status.contains == "vigente" || this.filters.status.contains == "Vigente"){
      delete params.where.status;
    }
    if (params.where.id == ""){
      delete params.where.id
    }
    if (params.where.shop_id == -1){
      delete params.where.shop_id;
    }
    if (this.fromDate && moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.init_date = params.where.init_date? params.where.init_date:{};
      params.where.init_date[">="] = moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.untilDate && moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.init_date = params.where.init_date? params.where.init_date:{};
      params.where.init_date["<="] = moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.fromDueDate && moment(this.fromDueDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.updated_due_date = params.where.updated_due_date? params.where.updated_due_date:{};
      params.where.updated_due_date[">="] = moment(this.fromDueDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.untilDueDate && moment(this.untilDueDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.updated_due_date = params.where.updated_due_date? params.where.updated_due_date:{};
      params.where.updated_due_date["<="] = moment(this.untilDueDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    this.exportParams = params;
    this.repurchaseService.query(params)
               .subscribe((repurchases) => {
                  let countParams = {
                    where: _.cloneDeep(params.where),
                  };
                  this.repurchaseService.count(countParams)
                  .subscribe((count) => {
                    this.totalItems = count.count;
                    if (this.totalItems == 1){
                      this.router.navigate(['/repurchase/view/'+repurchases[0].id])
                    }
                  });
                  this.repurchases = repurchases;
                  this.getRepurchasesProducts();
                  this.getRepurchaseRenewals();
                });
  }

  getRepurchasesProducts(){
    let params = {
      where: {
        repurchase_id: this.repurchases.map(e => e.id)
      }
    }
    this.repurchaseProductService.query(params)
    .subscribe((repurchaseProducts) => {
       let groupedRepurchaseProducts = _.groupBy(repurchaseProducts, (element)=> {return element.repurchase.id})
       this.repurchases.forEach( (p) =>{
         if (groupedRepurchaseProducts[p.id] && groupedRepurchaseProducts[p.id].length > 0){
          this.parseProductsDescription(p, groupedRepurchaseProducts[p.id]);
         }
       });
     });
  }

  getRepurchaseRenewals(){
      let params ={
        repurchase: this.repurchases.map(e => e.id)
      }
      this.repurchaseRenewalService.query(params).subscribe((repurchaseRenewals) =>{
        let groupedRepurchaseProducts = _.groupBy(repurchaseRenewals, (element)=> {return element.repurchase.id});
        this.repurchases.forEach((repurchase)=>{
          this.checkIfRepurchaseIsOutOfdateOrValid(repurchase, groupedRepurchaseProducts[repurchase.id]);
        });
      });
  }

  checkIfRepurchaseIsOutOfdateOrValid(repurchase,repurchaseRenewals){
    if (repurchase.status == "Vigente"){
      if (moment().isAfter(moment(repurchase.updated_due_date))){
          repurchase.status = "Fuera de fecha";
      }
    }else if (repurchase.status == "Fuera de fecha"){
      if (!moment().isAfter(moment(repurchase.updated_due_date))){
        repurchase.status = "Vigente";
      }  
    }
  }

  parseProductsDescription(element, groupedProducts){
    element.productDescription = "";
    groupedProducts.forEach(products=>{
      if ((products.product.type!="1" && products.product.type!="4") || ((products.product.type=="1" || products.product.type=="4") && !products.product.sub_type)){
        element.productDescription += this.getNameProductType(products.product.type)+"- ";
      }
      if ((products.product.type=="1" || products.product.type=="4") && products.product.sub_type){
        element.productDescription += this.getNameSubType(products.product.sub_type,products.product.type)+"- ";
      }
      if (products.product.brand){
        element.productDescription += "Marca:"+products.product.brand+", ";
      }
      if (products.product.model){
        element.productDescription += "Modelo:"+products.product.model+", ";
      }
      if (products.product.telephone_company){
        element.productDescription += "Compañia:"+products.product.telephone_company+", ";
      }
      if (products.product.storage_capacity){
        element.productDescription += "Capacidad:"+products.product.storage_capacity+", ";
      }
      if (products.product.status){
        element.productDescription += "Estado:"+products.product.status+", ";
      }
      if (products.product.imei){
        element.productDescription += "Imei:"+products.product.imei+", ";
      }
      if (products.product.imei2){
        element.productDescription += "Imei2:"+products.product.imei2+", ";
      }
      if (products.product.so){
        element.productDescription += "Sistema Operativo:"+products.product.so+", ";
      }
      if (products.product.ram){
        element.productDescription += "Ram:"+products.product.ram+", ";
      }
      if (products.product.description){
        element.productDescription += "Descripción:"+products.product.description+", ";
      }
      if (products.product.serial_number){
        element.productDescription += "Número de serie:"+products.product.serial_number+", ";
      }
      if (products.product.type=="3"){
        element.productDescription +="Cantidad:"+products.product.stock+", ";       
      }
      element.productDescription = element.productDescription .slice(0, -2) + " / ";
    });
  }

  getNameProductType(type){
    var productType= ["Móviles y Tablets","Consolas","Artículos Varios","PC's-portátiles"];
    return productType[type-1];
  }

  getNameSubType(subType, type){
    let subTypes = ["",""];  
    if (type == 1){
      subTypes =["Móvil","Tablet"];
    }else if (type == 4){
      subTypes =["PC","Portatil"];
    }
    return subTypes[subType-1];
  }
  delete(id){
    var r = confirm("¿Esta seguro de borrar esta recompra?");
    if (r == true) {
      let params = {
        where: {
          repurchase_id: id
        }
      }
      this.repurchaseProductService.query(params)
      .subscribe((purchaseProducts) => {
        purchaseProducts.forEach((e)=>{
          this.productService.delete(e.product.id).subscribe(()=>{});
          this.repurchaseProductService.delete(e.id).subscribe(()=>{});
        });
      });
      this.repurchaseService.delete(id).subscribe(()=>{
        this.getRepurchases(null);
      });
    }
  }

  search(nif){
    let params={
      nif: nif
    }
    this.personService.query(params)
    .subscribe((people) => {

        var person = people[0];
        if (person){
          if (person.warning){
            this.toastr.warning(person.warning, '¡Alerta!', {dismiss: "controlled",showCloseButton:true});
          }
          if (moment(person.nif_expiration_date).isBefore(moment())){
            this.toastr.warning('DNI caducado', '¡Fecha de caducidad del DNI!', {dismiss: "controlled",showCloseButton:true});
          }
          this.repurchaseService.query({
            where:{
              person_id: person.id,
              observations: { '!' : "" }
            }
          })
          .subscribe((repurchases) => {
            let message = "";
            repurchases.forEach((r)=>{
              message += r.observations + ". ";
            });
            this.toastr.warning(message, '¡Alerta!', {dismiss: "controlled",showCloseButton:true});
          });
        }
    });
  }

  exportRepurchasesToExcel(){
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };             
    let report = [
          {
              field1:"Número",
              field2:"Fecha",
              field3:"Fecha Vencimiento",
              field4:"NIF Cliente",
              field5:"Cliente",
              field6:"Artículos",
              field7:"Total Recompra",
              field8:"Total Vencimiento",
              field9:"Método de pago",
              field10:"Estado",
              
          }
      ]
      if (this.filters.status.contains == "Retirado"){
        report[0]["field11"] = "Ticket Retirada"
      }
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      this.repurchaseService.query(this.exportParams)
               .subscribe((repurchases) => {
      let paramsProducts = {
        where: {
          repurchase_id: repurchases.map(e => e.id)
        }
      }
      this.repurchaseProductService.query(paramsProducts)
      .subscribe((repurchaseProducts) => {
          let groupedRepurchaseProducts = _.groupBy(repurchaseProducts, (element)=> {return element.repurchase.id})
          repurchases.forEach( (p) =>{
            if (groupedRepurchaseProducts[p.id] && groupedRepurchaseProducts[p.id].length > 0){
              this.parseProductsDescription(p, groupedRepurchaseProducts[p.id]);
            }
          });
          let params ={
            repurchase: repurchases.map(e => e.id)
          }
          this.repurchaseRenewalService.query(params).subscribe((repurchaseRenewals) =>{
            this.repurchaseWithdrawalTicketService.query(params).subscribe((repurchaseWithdrawalTicket) =>{
              let groupedRepurchaseProducts = _.groupBy(repurchaseRenewals, (element)=> {return element.repurchase.id});
              let groupedRepurchasewithdrawal = _.groupBy(repurchaseWithdrawalTicket, (element)=> {return element.repurchase.id});
              repurchases.forEach((repurchase)=>{
                this.checkIfRepurchaseIsOutOfdateOrValid(repurchase, groupedRepurchaseProducts[repurchase.id]);
              });
              repurchases.forEach(repurchase =>{

                if (repurchase.productDescription){
                  repurchase.productDescription = repurchase.productDescription.replace(/&/g, "&amp;")
                                      .replace(/</g, "&lt;")
                                      .replace(/>/g, "&gt;")
                                      .replace(/"/g, "&quot;")
                                      .replace(/'/g, "&apos;");
                }
                    var row = {
                        field1:repurchase.id,
                        field2:repurchase.init_date?moment(repurchase.init_date).format("DD-MM-YYYY"):"",
                        field3:repurchase.updated_due_date?moment(repurchase.updated_due_date).format("DD-MM-YYYY"):"",
                        field4:repurchase.nif,
                        field5:repurchase.name +" "+ repurchase.surname +"/"+ repurchase.person.telephone,
                        field6:repurchase.productDescription,
                        field7:repurchase.total_purchase_amount,
                        field8:repurchase.total_due_amount,
                        field9:repurchase.method_of_payment?repurchase.method_of_payment:"",
                        field10:repurchase.status,
                    }

                    if (this.filters.status.contains == "Retirado"){
                      row["field11"] = groupedRepurchasewithdrawal[repurchase.id]?groupedRepurchasewithdrawal[repurchase.id][0].number_with_serie:""
                    }
                    report.push(row);
                  
                });
              
              var mystyle = {   
                  headers:true,       
                  columns:    
                      [{columnid:'field1',width:50,title: ''},   
                      {columnid:'field2',width:100,title: ''},
                      {columnid:'field3',width:100,title: 'LISTADO DE RECOMPRAS'}, 
                      {columnid:'field4',width:100,title: ''},
                      {columnid:'field5',width:300,title: ''},
                      {columnid:'field6',width:500,title: ''},
                      {columnid:'field7',width:50,title: ''},
                      {columnid:'field8',width:50,title: ''},
                      {columnid:'field9',width:50,title: ''}, 
                      {columnid:'field10',width:100,title: ''}, 
                    
                      ],
                  /*header*/
                
                  column: {  
                      style:{
                          Alignment:{
                              Horizontal:"Center",
                              Vertical:"Center",  
                              WrapText:1
                              
                          },
                          Font:{
                              Bold:"1",
                              Color:"#000000",
                              Size:10
                          },
                          
                          Interior:{
                              Color:"#7CEECE",
                              Pattern:"Solid"
                          }
                      }},
                cells: {    
                      0:{
                          0:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid",
                                      },
                              Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",
                                WrapText: 1,
                                  },  
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                              },                        
                              }  
                          },
                          1:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                          },  
                              Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },            
                                  }
                          },
                          2:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      }, 
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          }                
                                  }
                              },
                          3:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },            
                                    
                                  }
                              },
                          4:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              },
                          5:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              }, 
                          6:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                             
                              }
                              },
                          7:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },              
                                  }
                              },    
                          8:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },              
                                  }
                              },  
                              9:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                              },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1,
                                          },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },              
                                      }
                                  },       
                      }   
                },
          };

          if (this.filters.status.contains == "Retirado"){
            mystyle.columns.push({columnid:'field11',width:100,title: ''})
            mystyle.cells['0']['10'] = {style:{Interior:{ Color:"#95a5a6",Pattern:"Solid"}, Alignment:{Horizontal: 'Center',Vertical: 'Center',WrapText: 1,},Font:{Size:10,Bold:"1",Color:"#000000",},}}   
          }
          alasql.promise('SELECT * INTO XLSXML("Recompras_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
          .then(function(data){
              console.log('Data saved');
          }).catch(function(err){
              console.log('Error:', err);
          });
        });
        });
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/repurchase/components/list-repurchase/list-repurchase.component.ts